export const NAVIGATION_EVENT = "kavoosh:navigation";

export function currentPath(): string {
  return window.location.pathname.replace(/\/+$/, "") || "/";
}

function announceNavigation(): void {
  window.dispatchEvent(new Event(NAVIGATION_EVENT));
}

export function pushNavigation(nextPath: string): void {
  const current = `${window.location.pathname}${window.location.search}`;
  if (current !== nextPath) {
    window.history.pushState({}, "", nextPath);
  }
  announceNavigation();
}

export function replaceNavigation(nextPath: string): void {
  const current = `${window.location.pathname}${window.location.search}`;
  if (current !== nextPath) {
    window.history.replaceState({}, "", nextPath);
  }
  announceNavigation();
}
